import * as React from 'react'
import { Text, Stack } from '@doordash/design-language'
import { SectionContainer, ContentText } from '../../StyleComponents'
import {
  MaskedFoodSafetyImage,
  CateringBagImage,
  WashingHandsImage,
} from '../../images'
import { BulletList, ImageContainer } from '../../styles'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../i18n'
import { DASHER_STORE } from '../../../../../constants'
import { Interpolate } from '@doordash/lib-i18n'
import { CommonTextUrl } from '../../../../atoms/common-text-url'

const foodContaminationBullets = [
  i18n.t(i18nKeys.safetyCourse__list1_foodContamination),
  i18n.t(i18nKeys.safetyCourse__list2_foodContamination),
  i18n.t(i18nKeys.safetyCourse__list3_foodContamination),
]

const personalHygieneBullets = [
  i18n.t(i18nKeys.safetyCourse__list1_personalHygiene),
  i18n.t(i18nKeys.safetyCourse__list2_personalHygiene),
  i18n.t(i18nKeys.safetyCourse__list3_personalHygiene),
]

const stepName = 'FoodSafetySection'

export const FoodSafetySection = () => (
  <SectionContainer>
    <Text styles={Text.Styles.Bold32}>
      {i18n.t(i18nKeys.safetyCourse__title_foodSafety)}
    </Text>
    <ContentText>
      {i18n.t(i18nKeys.safetyCourse__subtitle1_foodSafety)}
    </ContentText>
    <ImageContainer>
      <MaskedFoodSafetyImage />
    </ImageContainer>
    <Text styles={Text.Styles.Bold24}>
      {i18n.t(i18nKeys.safetyCourse__title_foodContamination)}
    </Text>
    <BulletList>
      {foodContaminationBullets.map((bulletText, index) => (
        <li key={`${stepName}_foodContaminationBullets_${index}`}>
          <Stack>
            <ContentText>{bulletText}</ContentText>
          </Stack>
        </li>
      ))}
    </BulletList>
    <ImageContainer>
      <CateringBagImage />
    </ImageContainer>
    {/* Food and Temperature Section */}
    <Text styles={Text.Styles.Bold24}>
      {i18n.t(i18nKeys.safetyCourse__title_timeTemperature)}
    </Text>
    <BulletList>
      <li>
        <Stack>
          <ContentText>
            <Interpolate
              i18n={i18n}
              i18nKey={i18nKeys.safetyCourse__list1_timeTemperature}
              components={[<CommonTextUrl url={DASHER_STORE} />]}
            />
          </ContentText>
        </Stack>
      </li>
      <li>
        <Stack>
          <ContentText>
            {i18n.t(i18nKeys.safetyCourse__list2_timeTemperature)}
          </ContentText>
        </Stack>
      </li>
    </BulletList>
    <ImageContainer>
      <WashingHandsImage />
    </ImageContainer>

    {/* Personal Hygiene} */}
    <Text styles={Text.Styles.Bold24}>
      {i18n.t(i18nKeys.safetyCourse__title_personalHygiene)}
    </Text>
    <BulletList>
      {personalHygieneBullets.map((bulletText, index) => (
        <li key={`${stepName}personalHygieneBullets_${index}`}>
          <Stack>
            <ContentText>{bulletText}</ContentText>
          </Stack>
        </li>
      ))}
    </BulletList>
  </SectionContainer>
)
